export function hasCredentials() {
    const localAccessToken = window.localStorage.getItem('tmp-admin-jwt-access-token');
    const localRefreshToken = window.localStorage.getItem('tmp-admin-jwt-refresh-token');
    const expirationOfCredentials = window.localStorage.getItem('tmp-admin-jwt-credentials-expiration-date');
    return !(!localAccessToken || !localRefreshToken || !expirationOfCredentials);
}